<template>
  <div class="pages" :style="isShowPageTitle == false ? 'padding: 0' :''">
    <div v-if="isShowPageTitle" class="page-column-name">{{ $route.meta.title }}</div>
    <!-- <div class="pages-content"> -->
      <jd-form
        :form-info="inputInkidNeedAwardList"
        :isreData="true"
        :emitReset="true"
        @search="searchInkind"
        @reset="resetForm"
        ref="export_fun_swRef"
        class="mb16"
      >
      </jd-form>
      <div class="flex-spc-x mb12" style="margin-top: 15px">
            <jd-button @click="addCrowd(49)">按查询结果生成人群</jd-button>
            <jd-button type="text" @click="exportFn" v-preventReClick
                        >导出</jd-button>
      </div>
      <jd-table
        :loading="loading"
        :tableData="inkindTable"
        :pageInfo="{
          pageNum: formList.current,
          pageSize: formList.size,
          total: totalInkind,
        }"
        rowKey="id"
        @handlePage="handlePageInkind"
      >
        <el-table-column
          :prop="chaosParams"
          :label="`用户${grayText}`"
          min-width="150"
        >
        </el-table-column>
        <el-table-column prop="memberNick" label="用户昵称" width="180">
        </el-table-column>
        <el-table-column prop="activityName" label="关联活动" width="180">
        </el-table-column>
         <el-table-column prop="id" label="中奖ID" min-width="180">
        </el-table-column>
       <el-table-column prop="prizeType" label="奖品类型">
            <template slot-scope="scope">
              <span v-if="scope.row.prizeType == 1"> 优惠券 </span>
              <span v-else-if="scope.row.prizeType == 2"> 京豆 </span>
              <span v-else-if="scope.row.prizeType == 3"> 实物 </span>
              <span v-else-if="scope.row.prizeType == 4"> 店铺积分 </span>
              <span v-else-if="scope.row.prizeType == 5"> E卡 </span>
              <span v-else-if="scope.row.prizeType == 6"> 爱奇艺会员 </span>
              <span v-else-if="scope.row.prizeType == 7"> 京豆PlUS会员 </span>
              <span v-else-if="scope.row.prizeType == 8"> 红包 </span>
              <span v-else-if="scope.row.prizeType == 9"> 谢谢参与 </span>
              <span v-else-if="scope.row.prizeType == 10"> 礼品卡 </span>
              <span v-else-if="scope.row.prizeType == 13">令牌</span>
              <span v-else-if="scope.row.prizeType == 12">专享价</span>
              <span v-else> - </span>
            </template>
         </el-table-column>
         <el-table-column prop="prizeName" label="奖品名称">
            <template slot-scope="scope">
              <span v-if="scope.row.prizeName">
                {{ scope.row.prizeName }}
              </span>
              <span v-else> - </span>
            </template>
          </el-table-column>
         <el-table-column prop="statusStr" label="发放状态" min-width="120">
        </el-table-column>
        <el-table-column prop="joinTime" label="领奖时间" min-width="180">
        </el-table-column>
        <el-table-column label="发放时间" min-width="180" prop="grantTime">
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
           <template slot-scope="scope">
              <jd-button
                @click="recordMark(scope.row)"
                v-if="scope.row.status == 4"
                type="blueText"
              >
                标记发放</jd-button
              >
              <span v-else> - </span>
            </template>
        </el-table-column>
      </jd-table>
    <!-- </div> -->

    <!-- 录入快递单号弹窗 -->
    <jd-dialog
      title="录入快递单号"
      width="420px"
      :visible.sync="enterCoutierNumShow"
      @close="blankEnterCoutierNum"
      :append-to-body="true"
      class="enter_coutier_num_dialog"
    >
      <el-form
        :model="enterCoutierFrom"
        label-width="86px"
        class="new-input-box"
      >
        <el-form-item label="快递单号：">
          <el-input
            placeholder=""
            v-model="enterCoutierNum"
            style="width: 250px"
            @keydown.native="clearInput"
          ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <jd-button
          type="blue"
          style="margin-left: 8px"
          @click="enterCoutierSubmit"
          >确定</jd-button
        >
        <jd-button @click="blankEnterCoutierNum">取消</jd-button>
      </template>
    </jd-dialog>
    <!-- 批量标记发货弹窗 -->
    <jd-dialog
      title="批量发货"
      width="580px"
      :visible.sync="physicalBatchShipmentShow"
      @close="physicalBatchShipmentClose"
      :isShowSure="false"
      :isShowCancel="false"
      :append-to-body="true"
      class="physical_batch_shipment_dialog"
    >
      <el-form
        :model="physicalBatchShipmentFrom"
        label-width="120px"
        class="new-input-box"
      >
        <el-form-item label="上传文件：">
          <el-upload
            :before-upload="beforeUploadFile"
            :on-success="handleUpload"
            :show-file-list="false"
            class="upload-demo"
            :drag="true"
            multiple
            with-credentials
            :action="'/jd-hd-web/lockRight/markingSendStatusBatch/allActivities/fileUpload'"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label=" ">
          <jd-button type="blue" @click="handleDownloadTemplate"
            >下载模板</jd-button
          >
        </el-form-item>
        <el-form-item label=" " v-if="isShow">
          <p>
            导入成功{{ downloadResData.successNum || 0 }}条，导入失败{{
              downloadResData.failNum || 0
            }}条，导入失败相关用户昵称：
          </p>
          <div class="mlt12 download-box">
            <div
              class="downloaditem"
              v-for="(item, index) in downloadUserList"
              :key="index"
            >
              {{ index + 1 + ". " }}{{ item }}
            </div>
          </div>
        </el-form-item>
      </el-form>
    </jd-dialog>

    <!-- 生成人群 -->
    <crowdDialog
      v-if="isShowCrowdDialog"
      :isShowCrowdDialog="isShowCrowdDialog"
      :searchForm="crowCondition"
      :activityType="activityType"
      :source="source"
      :defaultValue="hasDefaultValue"
      :defaultValueText="defaultValueText"
      @close="crowdClose"
    />
    <generate
      :control="control1"
      v-if="control1"
      @transData="(val) => (control1 = val)"
      @transData1="getphone1"
    ></generate>

  </div>
</template>

<script>
import {
  signIssuance,
  getAllGoodsRecords,
  markingSendStatusLockRight,
  prizeRecords,
  exportPrizeRecords
} from "@/api/jhk/integralCenter/PointActivityAnalyticController";
import selectActivity from "@/components/select-activity";
import crowdDialog from "@/views/interactiveMarketing/activity/crowd-Dialog.vue";
import generate from "@/components/generate_report.vue";
export default {
  name: "gift_list",
  props: {
    isShowPageTitle: {
      type: Boolean,
      default: true,
    },
    activityType: {
      type: [Number , String],
      default: '',
    }
  },
  components: {
    selectActivity,
    crowdDialog,
    generate
  },
  created() {
     this.buriedPoint(1, "积分竞拍", "互动管理", "互动活动");
    if(this.activityType){
     this.activityObj.activityType = this.activityType;
    }
  },
  computed: {
    crowCondition() {
      return this.formList;
    },
    grayId() {
      return this.$store.getters.loginUserInfo.isGray ? 'xid' : 'pin'
    },
    grayText() {
      return this.$store.getters.loginUserInfo.isGray ? 'xid' : 'pin（加密）'
    },
    chaosParams() {
      return this.$store.getters.loginUserInfo.isGray ? 'chaosXid' : 'chaosPin'
    },
  },
  data() {
    return {
      control1: false,
      defaultValueText: "",
      hasDefaultValue: false,
      source: "",
      isShowCrowdDialog: false,
      isShow: false,
      physicalBatchShipmentFrom: {},
      physicalBatchShipmentShow: false,
      // 控制录入快递单号弹窗
      enterCoutierNumShow: false,
      // 快递单号
      enterCoutierNum: "",
      // 弹窗表单标识
      enterCoutierFrom: {},
      // 录入快递单号当前行数据存储
      enterCoutierRowData: {},
      inputInkidNeedAwardList: [
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "关联活动：",
          prop: "activityName",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "发放状态：",
          prop: "status",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
            { label: "待发放", value: "2" },
            { label: "已发放", value: "3" },
            { label: "发放失败", value: "4" },
            { label: "已失效", value: "8" },
          ],
        },
        {
          label: "奖品类型：",
          prop: "prizeType",
          type: "Select",
          placeholder: "请选择",
          options: [
            { label: "优惠券", value: 1 },
            { label: "京豆", value: 2 },
            { label: "实物", value: 3 },
            { label: "店铺积分", value: 4 },
            { label: "京东E卡", value: 5 },
            { label: "爱奇艺会员", value: 6 },
            { label: "PLUS会员", value: 7 },
            { label: "现金红包", value: 8 },
            { label: "礼品卡", value: 10 },
            { label: "令牌", value: 13 },
            { label: "专享价", value: 12 }
          ],
        },
        {
          label: "领奖时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "joinTimeStart",
          endKey: "joinTimeEnd",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
        {
          label: "发放时间：",
          type: "DateRange",
          dateType: "datetime",
          startKey: "grantTimeStart",
          endKey: "grantTimeEnd",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          defalutLimit: true,
        },
      ],
      // 实物奖品名单
      inkindTable: [],
      totalInkind: 0,
      formList: {
        pin: "",
        memberNick: "",
        activityName: "",
        status: "",
        prizeType: "",
        joinTimeStart: "",
        joinTimeEnd: "",
        grantTimeStart: "",
        grantTimeEnd: "",
        current: 1,
        size: 10,
      },
      loading: false,
      activityList: [
        {
          value: 1,
          label: "日历签到",
        },
        {
          value: 4,
          label: "关注店铺有礼",
        },
        {
          value: 17,
          label: "首单专享礼",
        },
        {
          value: 16,
          label: "下单有礼",
        },
        {
          value: 19,
          label: "下单抽奖",
        },
        {
          value: 18,
          label: "复购有礼",
        },
        {
          value: 34,
          label: "加购有礼",
        },
        {
          value: 36,
          label: "打榜有礼",
        },
        {
          value: 27,
          label: "预售有礼",
        },
        {
          value: 28,
          label: "预售抽奖",
        },
        {
          value: 8,
          label: "幸运抽奖",
        },
        {
          value: 7,
          label: "完善信息有礼",
        },
        {
          value: 20,
          label: "评价有礼",
        },
        {
          value: 3,
          label: "每日限时抢",
        },
        {
          value: 22,
          label: "天降红包雨",
        },
        {
          value: 23,
          label: "欢乐娃娃机",
        },
        {
          value: 24,
          label: "大家来找茬",
        },
        {
          value: 5,
          label: "邀请开卡有礼",
        },
        {
          value: 6,
          label: "邀请关注有礼",
        },
        {
          value: 21,
          label: "裂变神券",
        },
        {
          value: 31,
          label: "超级裂变券",
        },
        {
          value: 39,
          label: "生日有礼",
        },
        {
          value: 41,
          label: "晒单有礼",
        },
        {
          value: 43,
          label: "N元锁权",
        },
        {
          value: 44,
          label: "会员升级礼",
        },
        {
          value: 46,
          label: "满额有礼",
        },
        {
          value: 45,
          label: "锁权有礼",
        },
        {
          value: 47,
          label: "调查问卷",
        },
        {
          value: 48,
          label: "定时开奖",
        },
        {
          value: 50,
          label: "情书贺卡",
        },
        {
          value: 51,
          label: "0元试用",
        },
        {
          value: 52,
          label: "试用回购礼",
        },
        {
          value: 53,
          label: "购物打卡",
        },
        {
          value: 62,
          label: "集卡有礼",
        },
        {
          value: 64,
          label: "组队瓜分奖品",
        },
        {
          value: 65,
          label: "粉丝打卡",
        },
        {
          value: 66,
          label: "入会有礼",
        },
        {
          value: 67,
          label: "销售打榜",
        },
        {
          value: 68,
          label: "会员成长计划",
        },
        {
          value: 69,
          label: "拼团砍价",
        },
        {
          value: 70,
          label: "积分竞拍",
        },
        {
          value: 77,
          label: "购物车锦鲤",
        },
      ],
      activityObj: {
        activityType: "",
        activityId: "",
      },
      physicalBatchShipmentShow: false,
      downloadResData: {
        successNum: 0,
        failNum: 0,
      },
    };
  },
  watch: {
    grayId: {
      handler(val) {
        // grayId 为 computed，data() 初始化时尚不可用；此处同步更新搜索表单标签
        this.inputInkidNeedAwardList.forEach(item => {
          if(item.prop == 'pin'){
            item.label = `用户${val}：`
            item.prop = val
          }
        })
      },
      immediate: true,
    },
  },
  mounted() {
    this.formList[this.grayId] =  this.formList[this.grayId] || ""
    this.getList();
  },
  methods: {
    recordMark(row) {
      signIssuance({ id: row.recordId || row.id })
        .then((res) => {
          if (res && res.code == 1) {
            this.getList();
            this.$message.success(res.message);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((res) => {});
    },
      async exportFn() {
         this.control1 = true;
      },
    getphone1(exportRemark) {
        var formDate = this.formList;
        const params = {
          current: formDate.current,
          size: formDate.size,
          memberNick: formDate.memberNick ? formDate.memberNick : "",
          activityName: formDate.activityName ? formDate.activityName : "",
          status: formDate.status ? formDate.status : "",
          prizeType: formDate.prizeType ? formDate.prizeType : "",
          joinTimeStart: formDate.joinTimeStart ? formDate.joinTimeStart : "",
          joinTimeEnd: formDate.joinTimeEnd ? formDate.joinTimeEnd : "",
          grantTimeStart: formDate.grantTimeStart ? formDate.grantTimeStart : "",
          grantTimeEnd: formDate.grantTimeEnd ? formDate.grantTimeEnd : "",
          exportRemark,
        }
        params[this.grayId] = formDate[this.grayId] || ""
        exportPrizeRecords(params).then((res) => {
          if(res.code == 1){
            this.control1 = true;
          }else{
            this.$message.error(res.message);
          }
        })
    },
    addCrowd(val) {
      // 如果版本为京获客旗舰版需要校验用户时候有该按钮权限
      if (this.softType == 1 && !this.$store.getters.isJhkPlatformSeller) {
        return this.$message.warning("您不满足使用该功能，请联系专属客服了解~")
      }
      this.source = val;
      this.isShowCrowdDialog = true;
      this.hasDefaultValue = true;
      this.defaultValueText = "领奖记录";
    },
    crowdClose() {
      this.isShowCrowdDialog = false;
      // 关闭时重置
      if (this.hasDefaultValue) {
        this.hasDefaultValue = false;
        this.defaultValueText = "";
      }
    },
    // 点击解密  name: 修改的字段名   objdata：数组的名称, params:接口的参数  item：点击的对象    index：数组传下标值
    handleDecrypt(name, objdata, item, index) {
      let params =
        "decrypt" + name[0].toUpperCase() + name.substring(1, name.length);
      this.$decrypt
        .decryptJHK({ decryptContent: item[`${params}`] })
        .then((res) => {
          this[`${objdata}`][index][`${name}`] = res.message;
        });
    },
    resetForm(val) {
      this.formList[this.grayId] = "";
      this.formList.memberNick = "";
      this.formList.activityName = "";
      this.formList.status = "";
      this.formList.prizeType = "";
      this.formList.joinTimeStart = "";
      this.formList.joinTimeEnd = "";
      this.formList.grantTimeStart = "";
      this.formList.grantTimeEnd = "";
      this.formList.current = 1;
      this.formList.size = 10;
      this.getList();
    },
    getList() {
      this.loading = true;
      if(this.activityType){
        this.formList.activitySubTypes = this.activityType;
      }
      prizeRecords(this.formList)
        .then((res) => {
          this.loading = false;
          if (res.code == 1) {
            this.inkindTable = res.data.records || [];
            this.totalInkind = res.data.total || 0;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleDownloadTemplate() {
      let url =
        "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/%E6%89%B9%E9%87%8F%E5%8F%91%E8%B4%A7%E6%A8%A1%E6%9D%BF2.xlsx";
      let fileName = "实物奖品名单批量发货模板.xlsx";
      let elem = document.createElement("a");
      elem.style.display = "none";
      elem.href = url;
      elem.setAttribute("download", fileName);
      document.body.appendChild(elem);
      elem.click();
    },
    // 上传文件回调
    handleUpload(res) {
      this.isShow = true;
      // 上传文件
      if (res.code == 0) {
        this.$message.error(res.message);
      } else if (res.code == 1) {
        this.downloadResData = res.data;
        this.downloadUserList = res.data.failUserName;
        this.getList();
      }
    },
    // 上传文件处理
    beforeUploadFile(file) {
      console.log(file, "5433");
      if (
        file.type !=
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
        file.type != "application/vnd.ms-excel" &&
        file.type != "text/csv"
      ) {
        this.$message.warning("请上传正确格式的文件");
        return false;
      }
    },
    physicalBatchShipmentClose() {
      this.physicalBatchShipmentShow = false;
      this.downloadResData = {};
      this.downloadUserList = [];
    },
    markIss(row) {
      signIssuance({ id: row.recordId || row.id }).then((res) => {
        if (res && res.code == 1) {
          this.$message.success(res.message);
          this.getList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //标记发货
    changeShip(row) {
      this.$confirm("是否标记为发货?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
        customClass: "reverse-buttons",
      }).then(() => {
        this.markIss(row);
      });
    },
    // 取消发货
    cancelShip(row) {
      this.$confirm("是否取消发货?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
        customClass: "reverse-buttons",
      }).then(() => {
        this.markIss(row);
      });
    },
    // 监听录入快递单号按钮
    handleEnterCoutierNum(row) {
      this.enterCoutierNum = row.billCode;
      this.enterCoutierRowData = row;
      this.$forceUpdate();
      // 打开弹窗
      this.enterCoutierNumShow = true;
    },
    // 置空录入快递单号输入框并关闭弹窗
    blankEnterCoutierNum() {
      this.enterCoutierNum = "";
      // 清除当前行存储数据
      this.enterCoutierRowData = {};
      this.enterCoutierNumShow = false;
      this.sendOutGoodsShow = false;
    },
    clearInput(e) {
      let key = e.key;
      if (key === "e" || key === "E" || key === "+" || key === "-") {
        e.returnValue = false;
        return false;
      }
      return true;
    },
    // 录入快递单号提交
    enterCoutierSubmit() {
      let params = {
        billCode: this.enterCoutierNum,
        isUpdatePrizeStatus: true,
        id: this.enterCoutierRowData.id,
      };
      markingSendStatusLockRight(params)
        .then((res) => {
          if (res.code == 1) {
            this.getList();
            this.blankEnterCoutierNum();
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => {
          this.$message.error("录入快递单号失败");
        });
    },
    // 实物奖品搜索
    searchInkind(val) {
      this.formList.activitySubTypes = this.activityObj.activityType;
      this.formList.activityName = val.activityName;
      this.formList.status = val.status;
      this.formList.prizeType = val.prizeType;
      this.formList.joinTimeStart = val.joinTimeStart;
      this.formList.joinTimeEnd = val.joinTimeEnd;
      this.formList.grantTimeStart = val.grantTimeStart;
      this.formList.grantTimeEnd = val.grantTimeEnd;
      this.formList[this.grayId] = val[this.grayId] || "";
      this.formList.memberNick = val.memberNick;
      this.formList.current = 1;
      this.getList();
    },
    // 分页处理
    handlePageInkind(page) {
      this.formList.current = page.pageNum;
      this.formList.size = page.pageSize;
      this.getList();
    },
    // 批量标记发货
    batchMarkForShipment() {
      // 批量标记发货逻辑
      this.physicalBatchShipmentShow = true;
    },
    // 跳转到商品管理
    handleToGoods(id) {
      let routeUrl = this.$router.resolve({
        path: "/tool/prizeCenter/goodsManagement",
        query: {
          id,
          tabActive: 1,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.pages {
  background-color: #fff;
  padding: 16px;
  height: 100%;
  border-radius: 8px;
  // .pages-content {
  //   height: 100%;
  //   background: #ffffff;
  //   border-radius: 16px 16px 0 0;
  //   padding: 0 20px;
  //   overflow: hidden;
  //   padding: 20px;
    .goodsInfo {
      padding: 5px 0;
      display: flex;
      align-items: center;
      &_logo {
        display: flex;
        width: 80px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img {
          width: 70px;
          border-radius: 4px;
        }
      }
      &_text {
        flex: 1;
        color: #666666;
        cursor: pointer;
        margin-left: 5px;
        a {
          color: #666666;
          margin-top: 5px;
        }
      }
    }
    .physical_batch_shipment_dialog {
      .upload-demo {
        /deep/ .el-upload .el-upload-dragger {
          width: 250px;
        }
      }
      .download_template_box {
        position: absolute;
        right: 24px;
        top: 17%;
      }
      .downloadMsgBox {
        width: 100%;
        min-height: 100px;
      }
      .physical_batch_shipment_dialog_floor {
        text-align: right;
        width: 100%;
      }
    }
    //  为右侧固定列添加更高的z-index，确保操作列显示在其他列上方
     /deep/ .el-table__fixed-right {
        z-index: 99;
      }
  // }
  .mlt12 {
    margin-left: 24px;
  }
  .download-box {
    max-height: 300px;
    overflow-y: auto;
  }
  .downloaditem {
    line-height: 24px;
  }
}
</style>
